import { Typography } from "@pmag/ui-components";
import { type FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

import { ErrorFallback } from "./SvgModel.styles";

export const dataTestId = {
    fallback: "sparePartsFinder.overview.viewMode.tiles.svg.fallback",
};

export const SvgFallback: FunctionComponent = () => {
    return (
        <ErrorFallback data-testid={dataTestId.fallback}>
            <Typography variant="heading-07">
                <FormattedMessage id="sparePartsFinder.componentGroupOverview.card.bikeSVG.error" defaultMessage="No Image" />
            </Typography>
        </ErrorFallback>
    );
};
